import { useMemo } from 'react';

import { DROPDOWN_FETCH_PAGE_SIZE } from '@klareospace/pharos-lib-front-utils';
import type { MultiSelectOption } from '@klareospace/pharos-lib-web-utils';

import { useSpaces } from './use-spaces';

export interface UseSpacesForSelectOptions {
  enabled?: boolean;
}

export function useSpacesForSelect(options?: UseSpacesForSelectOptions): MultiSelectOption[] {
  const { enabled = true } = options ?? {};
  const { data } = useSpaces({ enabled, page: 1, pageSize: DROPDOWN_FETCH_PAGE_SIZE });

  return useMemo(() => (data?.items ?? []).map((space) => ({ label: space.name, value: space.id })), [data]);
}
